export const SUPPORT_EMAIL_SIGNUP = 'support@goodjourney.io';
export const BILLING_PLAN_TYPE = {
    monthly: 'monthly',
    annual: 'annual',
}